import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, Result, Radio, Space, Grid } from 'antd';
import { Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import {
	XThemeForm,
	XThemeContainer,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeSelect,
	XThemeRadio,
	XEditButtonIcon,
} from '../../styles/GlobalThemeStyle';

import moment from 'moment';
import CaseSearch from '../../components/CaseSearch/CaseSearch';
// actions
import {
	getHospitalsApi,
	getHospitalsReset,
} from '../../actions/getHospitalsAction';

import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../actions/getStateDropdownAction';
import { checkModulePermissions, truncateString } from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import HeaderFile from '../../components/Header/HeaderFile';
import DataTable from '../../components/DataTable/DataTable';
import Header from '../../components/Header/Header';
import { filterByLabel } from '../../utils/formFunctions';
import { getRegionsApi } from '../../actions/getRegionsAction';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import { XTheme2InnerCard, XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';

const Hospital = (props) => {
	const {
		getHospitals,
		getHospitalsState,
		getStateDropdownState,
		getStateDropdown,
		getRegionsState,
		getRegions,
	} = props;
	const defaultFilters = {
		search: '',
		page: 1,
		sort: 'updatedAt',
		sortDirection: 'descend',
		created_on: 'all',
		state: '',
		limit: 10,
		region: '',
	};
	const navigate = useNavigate();
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const [form2] = XThemeForm.useForm();

	const [open, setOpen] = useState(false);

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
	};

	const onChange = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};

	const columns = [
		{
			title: 'Name',
			width: 200,
			dataIndex: 'name',
			fixed: 'left',
			render: (name) => (
				<div>
					<div>{name}</div>
				</div>
			),
		},
		{
			title: 'Email Address',
			width: 200,
			dataIndex: 'contact_person_email_address',
			render: (contact_person_email_address) => (
				<div>
					<div>{contact_person_email_address}</div>
				</div>
			),
		},
		{
			title: 'Mobile Number',
			width: 200,
			dataIndex: 'contact_person_mobile_number',
			render: (contact_person_mobile_number) => (
				<div>
					<div>{contact_person_mobile_number}</div>
				</div>
			),
		},
		{
			title: 'Fax Number',
			width: 150,
			dataIndex: 'fax_number',
			render: (fax_number) => (
				<div>
					<div>{fax_number}</div>
				</div>
			),
		},
		{
			title: 'Address',
			width: 300,
			dataIndex: 'address',
			render: (address) => (
				<div>
					<div>{address}</div>
				</div>
			),
		},
		{
			title: 'State',
			width: 150,
			dataIndex: 'state',
			render: (state) => (
				<div>
					<div>{state}</div>
				</div>
			),
		},
		{
			title: 'City',
			width: 150,
			dataIndex: 'city',
			render: (city) => (
				<div>
					<div>{city}</div>
				</div>
			),
		},
		{
			title: 'Pincode',
			width: 150,
			dataIndex: 'pincode',
			render: (pincode) => (
				<div>
					<div>{pincode}</div>
				</div>
			),
		},
		{
			title: 'Region',
			width: 150,
			dataIndex: 'region',
			render: (region) => (
				<div>
					<div>{region}</div>
				</div>
			),
		},
		{
			title: 'Last Updated Date',
			width: 200,
			dataIndex: 'updatedAt',
			sorter: (a, b) => a.updatedAt - b.updatedAt,
			sortDirections: ['ascend', 'descend'],
			render: (updatedAt) => (
				<div>
					<div>{updatedAt}</div>
				</div>
			),
		},
		{
			title: 'Action',
			width: 150,
			dataIndex: 'action',
			fixed: 'right',
		},
	];

	const handleEdit = (item) => {
		navigate(`/hospital/edit/${item._id}`);
	};

	// use effects

	useEffect(() => {
		if (getHospitalsState.apiState === 'success') {
			if (getHospitalsState.data.all_hospitals.length > 0) {
				const updatedData = [];
				const updatedSearchOptions = [];
				setTotalRecords(getHospitalsState.data.total_count);
				getHospitalsState.data.all_hospitals.map((item, index) => {
					updatedSearchOptions.push({ value: item.name });
					updatedData.push({
						key: item._id,
						_id: item._id,
						name: item.name,
						contact_person_email_address:
							item.contact_person_email_address,
						contact_person_mobile_number:
							item.contact_person_mobile_number,
						fax_number: item.fax_number,
						address: item.address
							? truncateString(item.address, 30)
							: '',
						state: item.state,
						pincode: item.pincode,
						region: item.region,
						city: item.city,
						updatedAt: (
							<div className="showDate">
								<img
									className="img-fluid"
									src="./images/date-icon.svg"
									alt=""
								/>
								{moment(item.updatedAt).format('DD-MM-YYYY')}
							</div>
						),
						action: (
							<div className="text-center">
								<Row>
									<Col xs={{ span: 6, offset: 6 }}>
										<XEditButtonIcon
											onClick={() => {
												handleEdit(item);
											}}
											type="text"
										>
											<img
												src="./images/pencil.svg"
												alt=""
											/>
										</XEditButtonIcon>
									</Col>
								</Row>
							</div>
						),
					});
				});
				setTableData(updatedData);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getHospitalsState]);

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		console.log(
			checkModulePermissions('hospital-management').sub_modules.includes(
				'list-hospitals',
			),
		);
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions('hospital-management').sub_modules.includes(
			'list-hospitals',
		) && getHospitals({ ...updatedFilters });
	}, [window.location.search]);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Hospital" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="hospital" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				{checkModulePermissions('hospital-management').authorized ? (
					<>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									Hospital Management
								</XTheme2MainTitle>
								<XTheme2Para1>
									View and manage hospitals
								</XTheme2Para1>
							</Col>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-end"
							>
								{isMobile ? (
									<XTheme2Button
										shape="circle"
										size="large"
										className="noBackground borderColor"
										icon={<PlusOutlined />}
										onClick={() =>
											navigate('/hospital/add')
										}
									/>
								) : (
									<Link to="/hospital/add">
										<XTheme2Button
											size="large"
											icon={<PlusOutlined />}
										>
											Add Hospital
										</XTheme2Button>
									</Link>
								)}
							</Col>
						</Row>

						<XTheme2InnerCard
							className="mb-3"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-4">
								<CaseSearch
									filters={[
										<XThemeForm.Item
											name="state"
											colon={false}
											label="State"
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												allowClear
												className="noBorderRadius"
												placeholder="Select State"
												onFocus={() => {
													getStateDropdown();
												}}
												onClear={() => {
													setFilters({
														...filters,
														state: '',
														insurance_company: '',
													});
												}}
												showSearch={true}
												filterOption={filterByLabel}
												options={
													getStateDropdownState.apiState ===
														'success' &&
													getStateDropdownState.data
														.all_states?.length >
														0 &&
													getStateDropdownState.data.all_states.map(
														(itm) => {
															return {
																label: itm.state,
																value: itm.state,
																providers:
																	itm.providers,
															};
														},
													)
												}
												onSelect={(value, options) => {
													setFilters({
														...filters,
														state: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="region"
											label={'Region'}
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												placeholder="Select Region"
												name="region"
												showSearch={true}
												className="noBorderRadius"
												onFocus={() => {
													getRegions();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getRegions({
															search,
														});
													} else if (
														search.length === 0
													) {
														getRegions();
													}
												}}
												filterOption={filterByLabel}
												options={
													getRegionsState.apiState ===
														'success' &&
													getRegionsState.data.regions
														?.length > 0 &&
													getRegionsState.data.regions.map(
														(itm) => {
															return {
																label: itm.name,
																value: itm._id,
																providers:
																	itm.providers,
															};
														},
													)
												}
												onSelect={(value, options) => {
													setFilters({
														...filters,
														region: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="created_on"
											colon={false}
											label="Date Within"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChange}
												name="created_on"
											>
												<Row>
													{dateFilters.map(
														(item, index) => (
															<Col
																xs={12}
																lg={12}
																md={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
									]}
									onClose={onClose}
									open={open}
									applyFilters={applyFilters}
									form={form2}
									clearFilters={clearFilters}
								/>
								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col xs={12} sm={12} md={6} lg={4}>
										<h1
											className="cardTitle mb-0"
											style={{ fontSize: '18px' }}
										>
											Total {totalRecords} Hospitals
										</h1>
									</Col>
									<Col
										xs={24}
										sm={16}
										md={12}
										lg={12}
										className="d-none d-md-block"
									>
										<Space>
											<XTheme2InputText
												size="large"
												allowClear
												placeholder="Search for Hospitals"
												defaultValue={
													filters.search
														? filters.search
														: null
												}
												onChange={(v) => {
													if (v.target.value === '') {
														getHospitals({
															...filters,
															search: '',
														});
													} else {
														setFilters({
															...filters,
															search: v.target
																.value,
														});
													}
												}}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														const searchValue =
															filters.search
																? filters.search
																: '';
														if (searchValue) {
															getHospitals({
																...filters,
																search: searchValue,
															});
															setFilters({
																...filters,
																search: searchValue,
															});
														}
													}
												}}
											/>
											<XTheme2Button
												onClick={() => {
													// Trigger search when the button is clicked
													const searchValue =
														filters.search
															? filters.search
															: '';
													if (searchValue) {
														getHospitals({
															...filters,
															search: searchValue,
														});
														setFilters({
															...filters,
															search: searchValue,
														});
													}
												}}
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>
									<Col
										xs={12}
										sm={12}
										md={6}
										lg={8}
										className="text-end"
									>
										<Space>
											<XTheme2Button
												className="noBackground borderColor"
												shape="circle"
												size="large"
												onClick={() => showDrawer()}
												icon={
													<img
														src="/images/theme-filter-icon.svg"
														alt="filter"
													/>
												}
											/>

											{/* <XThemeFilterButton
												className="backgroundRevers"
												onClick={() =>
													navigate('/hospital/add')
												}
												icon={<PlusCircleFilled />}
											>
												Hospital
											</XThemeFilterButton> */}
										</Space>
									</Col>
								</Row>
							</div>
							<DataTable
								tableData={tableData}
								columns={columns}
								totalRecords={totalRecords}
								setFilters={setFilters}
								filters={filters}
								state={getHospitalsState.apiState}
								page={'hospital'}
								handleEdit={handleEdit}
							/>
						</XTheme2InnerCard>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getHospitalsState: state.getHospitals,
	addHospitalState: state.addHospital,
	editHospitalState: state.editHospital,
	getHospitalByIdState: state.getHospitalById,

	getStateDropdownState: state.getStateDropdown,
	getRegionsState: state.getRegions,
});

const mapDispatchToProps = (dispatch) => ({
	getHospitals: (data) => dispatch(getHospitalsApi(data)),
	getHospitalsReset: () => dispatch(getHospitalsReset()),
	getStateDropdown: (params) => dispatch(getStateDropdownApi(params)),
	getStateDropdownReset: () => dispatch(getStateDropdownReset()),
	getRegions: (params) => dispatch(getRegionsApi(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hospital);
